import type { ThemeOptions } from '@mui/material/styles'

import CustomPalette from './CustomPalette'

/**
 * Style overrides for Material UI components.
 */
export const components: ThemeOptions['components'] = {
  // Single source of truth for data-table COLUMN HEADERS so every table renders
  // them identically (16px, Regular weight, NightBlueLight). Without this, header
  // cells fall back to MUI's default head weight (500/Medium), which left tables
  // inconsistent. Set fontWeight on the cell only to deviate intentionally.
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: '16px',
        fontWeight: 400,
        color: CustomPalette.NightBlueLight,
      },
    },
  },
  // https://github.com/mui-org/material-ui/tree/next/packages/material-ui/src/Button
  MuiButton: {
    styleOverrides: {
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
  },
  // https://github.com/mui-org/material-ui/tree/next/packages/material-ui/src/ButtonGroup
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        '& .MuiDialog-paper': {
          borderRadius: '20px',
        },
      },
    },
  },
}
